import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { installCleanScreenshareAudio, installBroadcastAudioSdp } from './audio';
import './index.css';

// Force clean (unprocessed) screen/tab audio capture before any screenshare.
installCleanScreenshareAudio();
// Enable the Broadcast-preset stereo Opus SDP rewrite (gated; off until selected).
installBroadcastAudioSdp();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
